import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { 
  Box, 
  Grid, 
  VStack, 
  HStack,
  Text,
  Avatar,
  Badge,
  Button,
  IconButton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
  Flex,
  Icon,
  Divider,
  Tooltip,
  Spinner,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Portal,
  InputGroup,
  InputRightElement,
  Checkbox
} from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ZoomableAvatar from "components/Avatar/ZoomableAvatar.js";
import { 
  FiUser, 
  FiMail, 
  FiPhone, 
  FiCalendar,
  FiEdit3,
  FiGrid,
  FiBookOpen,
  FiHeart,
  FiUserCheck,
  FiFolder,
  FiAward,
  FiCreditCard,
  FiFileText,
  FiActivity,
  FiAlertTriangle,
  FiTrendingUp,
  FiUsers,
  FiSettings,
  FiDownload,
  FiEye,
  FiEyeOff,
  FiClock,
  FiLock,
  FiCamera,
  FiChevronLeft,
  FiChevronRight
} from "react-icons/fi";
import { 
  FaMoneyBillWave, 
  FaTicketAlt, 
  FaTrash,
  FaPenFancy
} from "react-icons/fa";
import { IoDocumentsSharp } from "react-icons/io5";
import { useParams, useHistory } from 'react-router-dom';
import { AVATAR_GRADIENTS, getInitials } from 'utils/avatarStyles';
import { codeToDisplayLabel, normalizeCourseName } from 'utils/courseUtils';

// Servicios
import { getUserFiles, uploadAvatar } from "services/userService";
import { getRespondentSurveys, getAllSurveys } from "services/surveyService";
import { loadCategories, getColorForCategory, getCategoriesForRole } from "services/surveyCategoriesService";
import { getCustomer, getOrders, getAllCustomerOrders, updateCustomer, getProducts, sendPaymentReport } from "services/woo";
import { updateAdminUser } from "services/wpUsers";
import { getRoleDisplay } from "utils/roleLabel";
import { useModuleCheck, MODULES, getSiteConfig, useUserAuth, useRoleModuleAccess, getCategoryDisplayName, canUserAccessCategory, filterCategoriesByRole, SURVEY_CATEGORIES, normalizeCategoryName } from "utils/site";
import { useForm } from "react-hook-form";
import { format } from "rut.js";
import { createLogger } from "utils/logger";

// Componentes
import { MetricCard } from "components/Card/EducationalCard";
import BatchUsersOrderCreate from "../Suscriptions/components/BatchUsersOrderCreate";
import BatchUsersOrderDelete from "../Suscriptions/components/BatchUsersOrderDelete";
import BatchUsersTicketCreate from "../Suscriptions/components/BatchUsersTicketCreate";
import BatchUsersGroup from "../Suscriptions/components/BatchUsersGroup";
import BatchUsersSubscription from "../Suscriptions/components/BatchUsersSubscription";

// Modales originales
import ModalOrderEdit from "components/Modal/ModalOrderEdit";
import DocumentViewerModal from "components/Modal/DocumentViewerModal";
import ModalAddSurveyResponse from "components/Modal/ModalAddSurveyResponse";
import ModalSurveyResponse from "components/Modal/ModalSurveyResponse";
import { getSurveyResponse } from "services/surveyService";

// Componentes originales del perfil
import Files from "./components/Files";
import FichasTab from "./components/Fichas/FichasTab";
import Payments from "./components/Payments";
import CasosListView from "./components/CasosListView";
import CasoDetailView from "./components/CasoDetailView";
import CasoCreateModal from "./components/CasoCreateModal";
import QRCard from "./components/QRCard";
import StudentStatusCard from "./components/StudentStatusCard";
import AntecedentesTab from "./components/AntecedentesTab";
import StudentAgendaTab from "./components/StudentAgendaTab";
import { StudentAccessHistory } from "../AccessControl/components/StudentHistoryModal";

const Profile = () => {
  const { id } = useParams();
  const history = useHistory();

  // Logger optimizado para development (memoizado)
  const logger = useMemo(() => createLogger('Profile'), []);
  
  // Estados
  const [customer, setCustomer] = useState({});
  const [userFiles, setUserFiles] = useState([]);
  const [userSurveys, setUserSurveys] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  const avatarInputRef = useRef(null);
  // LocalStorage para persistencia de tab
  const loadTabFromStorage = () => {
    try {
      const saved = localStorage.getItem('profile-current-tab-v2');
      return saved ? parseInt(JSON.parse(saved)) : 0;
    } catch {
      return 0;
    }
  };

  const [activeTab, setActiveTab] = useState(loadTabFromStorage);
  const [groups, setGroups] = useState([]);
  
  // Estados para modales
  const [showOrderCreate, setShowOrderCreate] = useState(false);
  const [showOrderDelete, setShowOrderDelete] = useState(false);
  const [showTicketCreate, setShowTicketCreate] = useState(false);
  const [showGroupChange, setShowGroupChange] = useState(false);
  const [showSubscriptionChange, setShowSubscriptionChange] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  
  // Estados para modales originales
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [caseModalData, setCaseModalData] = useState(null);

  // Estados para navegación de casos
  const [casosView, setCasosView] = useState('list'); // 'list' | 'detail'
  const [selectedCaso, setSelectedCaso] = useState(null);
  const [showCasoCreateModal, setShowCasoCreateModal] = useState(false);
  const [selectedFormForCase, setSelectedFormForCase] = useState(null); // { formId, casoId }
  
  // Estados para confirmaciones
  const { isOpen: isEmailOpen, onOpen: onEmailOpen, onClose: onEmailClose } = useDisclosure();
  const { isOpen: isPhoneOpen, onOpen: onPhoneOpen, onClose: onPhoneClose } = useDisclosure();
  const { isOpen: isReportOpen, onOpen: onReportOpen, onClose: onReportClose } = useDisclosure();
  const cancelRef = React.useRef();
  
  // Estados para edición de usuario
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Estado para envío de reporte
  const [loadingSendReport, setLoadingSendReport] = useState(false);
  const toast = useToast();

  // Setter usado por el acceso rápido a formularios (handleQuickFormAccess) — el valor en sí
  // ya no se lee aquí, FichasTab maneja su propio estado de categoría/navegación.
  const [, setSelectedSurveyCategory] = useState('all');
  
  // Estados para formularios disponibles
  const [availableSurveys, setAvailableSurveys] = useState([]);
  const [loadingAvailableSurveys, setLoadingAvailableSurveys] = useState(false);
  const [modalOpenedFromCases, setModalOpenedFromCases] = useState(false);
  const [modalDirectAccessMode, setModalDirectAccessMode] = useState(null); // null = lista, 'categoria' = acceso directo a categoría
  
  // Form para edición
  const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm();

  // Usuario autenticado para filtros específicos de pagos
  const { user: authUser } = useUserAuth();
  // Fallback restrictivo: mientras authUser no resuelve (o falla la auth), no se debe
  // asumir 'administrador' — eso expondría categorías restringidas (ej. documentos) a
  // cualquier rol durante la carga inicial. canUserAccessCategory() deniega por defecto
  // cuando el rol es null/undefined.
  const userRole = authUser?.role || null;
  const isAdmin = userRole === 'administrador';
  const hasAgenda = useRoleModuleAccess(MODULES.AGENDA);

  // Mapeo de iconos por categoría de formulario
  const categoryIconMap = {
    'atencion': FiUserCheck,
    'matriculas': FiBookOpen,
    'salud': FiHeart,
    'documentos': FiFileText,
    'becas': FiAward,
    'casos': FiAlertTriangle,
    'otros': FiFolder
  };
  
  // Módulos básicos - Fixed: Hooks cannot be called inside useMemo
  const paymentsModule = useModuleCheck(MODULES.PAYMENTS);
  const ticketsModule = useModuleCheck(MODULES.TICKETS);
  const surveysModule = useModuleCheck(MODULES.SURVEYS);
  const filesModule = useModuleCheck(MODULES.FILES);
  const subscriptionsModule = useModuleCheck(MODULES.SUBSCRIPTIONS);

  const moduleStatus = useMemo(() => ({
    [MODULES.PAYMENTS]: paymentsModule,
    [MODULES.TICKETS]: ticketsModule,
    [MODULES.SURVEYS]: surveysModule,
    [MODULES.FILES]: filesModule,
    [MODULES.SUBSCRIPTIONS]: subscriptionsModule
  }), [paymentsModule, ticketsModule, surveysModule, filesModule, subscriptionsModule]);
  
  // Filtros específicos por rol SOLO para elementos de pagos
  const showPayments = paymentsModule && userRole === 'administrador';
  const showSubscriptions = subscriptionsModule && userRole === 'administrador';

  // Función helper para calcular el índice de la pestaña de casos
  const getCasesTabIndex = () => {
    let index = 0;
    if (surveysModule) index++; // Fichas
    if (hasAgenda) index++; // Agenda
    if (showPayments) index++; // Pagos
    if (filesModule) index++; // Archivos
    return index;
  };

  // Categorías de surveys ya importadas arriba
  
  // Función para obtener iconos por categoría
  const getCategoryIcon = (category) => {
    const normalized = normalizeCategoryName(category);
    const iconMap = {
      'Matriculas': FiBookOpen,
      'Salud': FiHeart,
      'Atencion': FiUserCheck,
      'Documentos': FiFolder,
      'Becas': FiAward,
      'Casos': FiAlertTriangle,
      'otros': FiFileText
    };
    return iconMap[normalized] || FiFileText;
  };
  
  // Carga categorías desde la DB al montar — garantiza que canUserAccessCategory use datos reales
  const [categoriesVersion, setCategoriesVersion] = useState(0);
  useEffect(() => {
    loadCategories().then(() => setCategoriesVersion(v => v + 1));
  }, []);

  // Color por categoría — lee desde la DB
  const getCategoryColor = (category) => getColorForCategory(category);

  // Mapea el colorScheme de Chakra (configurado en DB) a un pastel V1 para los chips de categoría
  const CHAKRA_TO_PASTEL = {
    blue: 'sky', cyan: 'sky', teal: 'teal', green: 'mint', red: 'rose',
    pink: 'rose', orange: 'butter', yellow: 'butter', purple: 'lav', gray: 'cream',
  };
  const pastelForCategory = (chakraColor) => CHAKRA_TO_PASTEL[chakraColor] || 'sky';

  // Fichas filtradas por rol — el tab Fichas (FichasTab) maneja su propio filtro/navegación
  // interna por categoría, así que aquí solo se filtra por permisos de rol.
  const filteredSurveys = useMemo(() => {
    if (!userSurveys || userSurveys.length === 0) return [];
    // categoriesVersion asegura re-cómputo cuando carga el caché de categorías
    const result = userSurveys.filter(item => {
      const category = item.survey?.category || 'otros';
      return canUserAccessCategory(userRole, category);
    });
    return result;
  }, [userSurveys, userRole, categoriesVersion]);

  // Colores del tema
  const bgMain = useColorModeValue('gray.50', 'gray.900');
  const bgCard = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const mutedText = useColorModeValue('gray.600', 'gray.400');
  
  // Colores específicos para las tarjetas de últimos registros
  const cardItemBg = useColorModeValue('gray.50', 'gray.700');
  const cardItemBorder = useColorModeValue('gray.200', 'gray.500');
  const cardItemTextColor = useColorModeValue('gray.700', 'gray.100');

  // FASE 1: Funciones separadas para optimizar llamadas API
  
  // Cargar datos base del sistema (grupos y productos)
  const loadBaseData = useCallback(async () => {
    try {
      // Cargar grupos desde la configuración del sitio
      const config = JSON.parse(getSiteConfig());
      const loadedGroups = config?.groups || [];
      setGroups(loadedGroups);
      
      // Cargar productos para suscripciones
      const allProducts = await getProducts();
      setProducts(allProducts || []);
    } catch (error) {
      logger.error('Error loading base data:', error);
    }
  }, []);

  // Funciones sin useCallback para evitar dependencias circulares
  // silent=true evita el spinner de pantalla completa — usado para refrescos
  // en segundo plano (ej. auto-sync de Antecedentes) que no deben recargar todo el perfil
  const currentIdRef = useRef(id);
  currentIdRef.current = id;

  const fetchCustomer = async (silent = false) => {
    if (!id) return;
    const requestedId = id;

    try {
      if (!silent) setLoading(true);
      const response = await getCustomer(requestedId);
      // Ignorar respuesta tardía si ya se navegó a otro alumno
      if (currentIdRef.current !== requestedId) return;
      if (response.data) {
        setCustomer(response.data);
        document.title = `Perfil: ${response.data.first_name} ${response.data.last_name}`;
      }
    } catch (error) {
      logger.error('Error fetching customer:', error);
      if (!silent) setError('Error al cargar los datos del cliente');
    } finally {
      if (!silent) setLoading(false);
    }
  };

  // Cargar archivos del usuario
  const fetchUserFiles = async () => {
    if (!customer.username || !filesModule) return;
    
    try {
      const getFiles = await getUserFiles(customer.username, { excludeCasos: false });
      setUserFiles(getFiles.data || []);
    } catch (error) {
      logger.error('Error loading user files:', error);
      setUserFiles([]);
    }
  };

  // Cargar órdenes del usuario
  const fetchOrders = async () => {
    if (!customer.id || !paymentsModule) return;

    try {
      const orders = await getAllCustomerOrders(customer.id);
      setOrdersData(orders);
    } catch (error) {
      logger.error('Error loading user orders:', error);
      setOrdersData([]);
    }
  };

  // useEffect optimizado para evitar múltiples llamadas
  useEffect(() => {
    loadBaseData();
  }, []); // Solo una vez

  useEffect(() => {
    if (id) {
      // Limpiar datos del alumno anterior: si no, Antecedentes (auto-sync) puede
      // combinar el customer nuevo con fichas/archivos/órdenes del anterior
      setCustomer({});
      setUserSurveys([]);
      setUserFiles([]);
      setOrdersData([]);
      fetchCustomer();
    }
  }, [id]); // Solo cuando cambia el ID del usuario

  // useEffect que se ejecuta DESPUÉS de que customer se carga
  useEffect(() => {
    if (customer.username && filesModule) {
      fetchUserFiles();
    }
  }, [customer.username, filesModule]); // Dependencias directas

  useEffect(() => {
    if (!customer.username || !surveysModule) return;
    // Ignorar respuestas tardías de un alumno que ya no está en pantalla
    let cancelled = false;
    getRespondentSurveys(customer.username)
      .then(r => { if (!cancelled) setUserSurveys(r.data || r || []); })
      .catch(error => {
        logger.error('Error loading user surveys:', error);
        if (!cancelled) setUserSurveys([]);
      });
    return () => { cancelled = true; };
  }, [customer.username, surveysModule]); // Dependencias directas

  useEffect(() => {
    if (customer.id && paymentsModule) {
      fetchOrders();
    }
  }, [customer.id, paymentsModule]); // Dependencias directas

  // Cargar formularios disponibles (optimizado - solo una vez)
  const loadAvailableSurveys = useCallback(async () => {
    // Solo cargar si no están ya cargadas y no está cargando
    if (availableSurveys.length > 0 || loadingAvailableSurveys) return;
    
    try {
      setLoadingAvailableSurveys(true);
      const siteConfig = JSON.parse(getSiteConfig() || '{}');
      const siteName = siteConfig.name || '';
      
      // Mapeo de sitios
      const glosario = { 
        'Pagos CapitalWeb CL': 'pagos-capitalweb-cl', 
        'Pagos BlasPascal CL': 'blaspascal', 
        'Pagos Testing': 'blaspascal' 
      };
      const siteSlug = glosario[siteName] || 'blaspascal';
      
      // Pasar userData a getAllSurveys para evitar llamada redundante getUserAuth
      const surveys = await getAllSurveys(siteSlug, { userAuth: authUser });
      setAvailableSurveys(surveys || []);
    } catch (error) {
      logger.error('Error loading available surveys:', error);
      setAvailableSurveys([]);
    } finally {
      setLoadingAvailableSurveys(false);
    }
  }, [availableSurveys.length, loadingAvailableSurveys, authUser]);

  // Cargar formularios al montar y cuando authUser resuelva (evita pasar un
  // authUser nulo/obsoleto a loadAvailableSurveys — el guard interno de
  // loadAvailableSurveys evita refetch una vez que availableSurveys ya cargó)
  useEffect(() => {
    loadAvailableSurveys();
  }, [authUser]); // eslint-disable-line

  // Función para manejar acceso directo a formularios por categoría
  const handleQuickFormAccess = (category) => {
    logger.log('🚀 handleQuickFormAccess - Abriendo formulario para categoría:', category);

    // Verificar si el usuario puede acceder a esta categoría
    if (!canUserAccessCategory(userRole, category)) {
      toast({
        title: 'Acceso denegado',
        description: `No tienes permisos para acceder a la categoría ${category}`,
        status: 'warning',
        duration: 3000,
        isClosable: true
      });
      return;
    }

    // Si es un formulario de casos, marcar para mantener la pestaña casos activa
    if ((category === 'casos' || category === 'Casos') && canUserAccessCategory(userRole, 'casos')) {
      setModalOpenedFromCases(true);
      setActiveTab(getCasesTabIndex());
      setModalDirectAccessMode('casos'); // Acceso directo a casos
    } else {
      setActiveTab(0);
      // Buscar el primer formulario de esa categoría para acceso directo
      const categoryForms = availableSurveys.filter(survey =>
        survey.category === category && canUserAccessCategory(userRole, survey.category)
      );

      if (categoryForms.length > 0) {
        // Pasar el primer formulario como acceso directo
        setModalDirectAccessMode({ id: categoryForms[0].id, slug: categoryForms[0].slug });
        logger.log(`🎯 Abriendo directamente formulario:`, categoryForms[0].name);
      } else {
        setModalDirectAccessMode(null);
        logger.warn(`No hay formularios disponibles para la categoría: ${category}`);
        toast({
          title: 'Sin formularios',
          description: `No hay formularios disponibles para ${category}`,
          status: 'info',
          duration: 3000,
          isClosable: true
        });
        return;
      }
    }

    setSelectedSurveyCategory(category);
    setShowSurveyModal(true);
  };

  // Categorías que llena el apoderado, no administración.
  const APODERADO_CATEGORIES = ['matriculas', 'salud', 'documentos', 'becas'];

  // Categorías que se llenan desde un flujo aparte (scanner de retiros/salidas
  // pedagógicas, gestión de casos), nunca manualmente desde este dropdown.
  const EXTERNAL_FLOW_CATEGORIES = ['casos', 'retiros', 'salidas-pedagogicas'];

  // Categorías disponibles para el menú "Formularios" (botón violeta).
  // Incluye: categorías con surveys reales en la API + categorías accesibles de la DB sin surveys.
  const availableFormCategories = useMemo(() => {
    // Contar surveys por categoría (solo los accesibles por rol)
    const countMap = availableSurveys
      .filter(s => canUserAccessCategory(userRole, s.category || 'otros'))
      .reduce((acc, s) => {
        const cat = s.category || 'otros';
        acc[cat] = (acc[cat] || 0) + 1;
        return acc;
      }, {});

    // Categorías de la DB accesibles para el rol (fill:true) que el usuario puede llenar
    const dbFillSlugs = getCategoriesForRole(userRole, 'fill').map(c => c.slug);

    // Unión: categorías con surveys + categorías fillables de la DB
    // Formularios de apoderado y de flujos externos (casos/retiros/salidas-pedagogicas)
    // se llenan desde otro lado, nunca manualmente desde este dropdown
    const allSlugs = [...new Set([...Object.keys(countMap), ...dbFillSlugs])]
      .filter(slug => !APODERADO_CATEGORIES.includes(slug) && !EXTERNAL_FLOW_CATEGORIES.includes(slug));

    return allSlugs
      .sort()
      .map(slug => ({
        category: slug,
        count: countMap[slug] || 0,
        icon: categoryIconMap[slug] || FiFolder,
      }));
  }, [availableSurveys, categoryIconMap, userRole, categoriesVersion]);

  // Categorías para el tab "Fichas": las accesibles por rol (incluye vacías) +
  // respuestas existentes del alumno visibles para el rol.
  const surveyCategoryList = useMemo(() => {
    const dbSlugs = getCategoriesForRole(userRole, 'view').map(c => c.slug);
    const formSlugs = availableSurveys
      .filter(s => canUserAccessCategory(userRole, s.category || 'otros'))
      .map(s => s.category || 'otros');
    // Respuestas existentes filtradas por rol — evita mostrar categorías restringidas
    const responseSlugs = (userSurveys || [])
      .filter(item => canUserAccessCategory(userRole, item.survey?.category || 'otros'))
      .map(item => item.survey?.category || 'otros');

    const allSlugs = [...new Set([...dbSlugs, ...formSlugs, ...responseSlugs])].sort();

    return allSlugs.map(slug => {
      // Quita el emoji inicial del label de fallback (ej. "📋 Formularios de Matrícula" → "Formularios de Matrícula")
      const rawDisplayName = getCategoryDisplayName(slug);
      const displayName = rawDisplayName?.includes(' ') ? rawDisplayName.split(' ').slice(1).join(' ') : rawDisplayName;
      return {
        slug,
        count: (userSurveys || []).filter(item => (item.survey?.category || 'otros') === slug).length,
        icon: getCategoryIcon(slug),
        pastel: pastelForCategory(getCategoryColor(slug)),
        displayName,
      };
    });
  }, [userRole, availableSurveys, userSurveys, categoriesVersion]);

  // Filtrar formularios específicos para casos
  const availableCaseForms = useMemo(() => {
    return availableSurveys.filter(survey =>
      survey.category === 'casos' && canUserAccessCategory(userRole, 'casos')
    );
  }, [availableSurveys, userRole]);

  // Subida de foto de perfil del alumno
  const handleAvatarUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !customer?.username) return;
    if (!file.type.startsWith('image/')) {
      toast({ title: 'Solo se aceptan imágenes', status: 'warning', duration: 3000, isClosable: true });
      return;
    }
    setUploadingAvatar(true);
    try {
      const result = await uploadAvatar(customer.username, file);
      if (!result.success) throw new Error(result.message);
      await updateCustomer(customer.id, {
        meta_data: [{ key: 'avatar_url', value: result.url }],
      });
      // Refrescar datos del cliente para que se actualice el Avatar
      setCustomer(prev => ({
        ...prev,
        meta_data: [
          ...(prev.meta_data || []).filter(m => m.key !== 'avatar_url'),
          { key: 'avatar_url', value: result.url },
        ],
      }));
      toast({ title: 'Foto actualizada correctamente', status: 'success', duration: 3000, isClosable: true });
    } catch (err) {
      toast({ title: 'Error al subir la foto', description: err.message, status: 'error', duration: 4000, isClosable: true });
    } finally {
      setUploadingAvatar(false);
      if (avatarInputRef.current) avatarInputRef.current.value = '';
    }
  };

  // Función para cerrar modales
  const handleActionComplete = () => {
    setShowOrderCreate(false);
    setShowOrderDelete(false);
    setShowTicketCreate(false);
    setShowGroupChange(false);
    setShowSubscriptionChange(false);
    setShowSurveyModal(false);
    // Solo refrescar si hubo cambios reales
    fetchCustomer();
  };

  // Función específica para cerrar el modal de survey
  const handleSurveyModalClose = () => {
    setShowSurveyModal(false);
  };

  // Función optimizada para refrescar solo los surveys sin refrescar todo el perfil
  const updateSurveyResponses = useCallback(async () => {
    try {
      if (moduleStatus[MODULES.SURVEYS] && customer.username) {
        const getSurveys = await getRespondentSurveys(customer.username);
        setUserSurveys(getSurveys.data || getSurveys || []);
      }
    } catch (error) {
    }
  }, [customer.username, moduleStatus]);

  // Funciones para manejar navegación de casos
  const handleSelectCaso = (caso) => {
    setSelectedCaso(caso);
    setCasosView('detail');
  };

  const handleBackToCasos = () => {
    setSelectedCaso(null);
    setCasosView('list');
  };

  const handleCreateCaso = () => {
    setShowCasoCreateModal(true);
  };

  const handleCasoCreated = (nuevoCaso) => {
    // Refrescar la lista y mostrarla
    setCasosView('list');
    // Opcionalmente podrías navegar al nuevo caso creado
    // setSelectedCaso(nuevoCaso);
    // setCasosView('detail');
  };

  const handleFichaClick = (ficha) => {
    // Similar a handleOpenCaseModal pero para fichas individuales
    setModalOpenedFromCases(true);
    handleOpenCaseModal(ficha);
  };

  const handleAddFicha = (formId) => {
    // Abrir modal de survey para agregar nueva ficha al caso
    setModalOpenedFromCases(true);
    setModalDirectAccessMode('casos'); // Acceso directo a casos
    if (formId) {
      // Si se especifica un formulario, podrías pre-seleccionarlo
      setSelectedSurveyCategory('Casos');
    }
    setShowSurveyModal(true);
  };

  // Función para cuando se completa el llenado de survey (ahora optimizada)
  const handleSurveyComplete = () => {
    setShowSurveyModal(false);

    // Limpiar estado de formulario seleccionado para caso
    setSelectedFormForCase(null);

    // Resetear modo de acceso directo
    setModalDirectAccessMode(null);

    // Si el modal se abrió desde la pestaña Casos, mantener esa pestaña activa
    if (modalOpenedFromCases && canUserAccessCategory(userRole, 'casos')) {
      // Calcular el índice de la pestaña "Casos"
      setActiveTab(getCasesTabIndex());
      setModalOpenedFromCases(false);
    }

    // Solo refreschar surveys, no todo el perfil
    updateSurveyResponses();
  };

  // Función específica para cuando se crean/eliminan órdenes (solo refresca pagos)
  const handleOrderActionComplete = () => {
    setShowOrderCreate(false);
    setShowOrderDelete(false);
    // Solo refrescar los pagos, no todo el perfil
    handlePaymentsRefresh();
  };

  // Funciones para modales originales
  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShowFileModal(true);
  };

  const handleCloseModals = () => {
    setShowOrderModal(false);
    setShowFileModal(false);
    setSelectedOrder(null);
    setSelectedFile(null);
    // No refrescar automáticamente - solo si es necesario
  };

  // Función específica para refrescar solo cuando hay cambios
  const handleDataRefresh = () => {
    fetchCustomer();
  };

  // Función específica para refrescar solo los pagos
  const handlePaymentsRefresh = async () => {
    if (!moduleStatus[MODULES.PAYMENTS] || !customer.id) return;

    try {
      setPaymentsLoading(true);
      const orders = await getAllCustomerOrders(customer.id);
      setOrdersData(orders);
    } catch (error) {
    } finally {
      setPaymentsLoading(false);
    }
  };

  // Función para abrir modal de detalle de caso (similar a handleOpenModalSurveyResponse)
  const handleOpenCaseModal = async (caso) => {
    setCaseModalData(null);
    setSelectedCase(caso);
    setShowCaseModal(true);

    // Cargar datos completos del survey response
    try {
      const surveyResponse = await getSurveyResponse(caso.id);
      setCaseModalData(surveyResponse);
    } catch (error) {
      setCaseModalData({ error: 'No se pudieron cargar los datos del caso' });
    }
  };

  // Funciones para confirmaciones
  const handleConfirmEmail = () => {
    window.open(`mailto:${customer.email}`);
    onEmailClose();
  };

  const handleConfirmPhone = () => {
    const phoneNumber = customer.meta_data?.find(m => m.key === 'telefono')?.value || 
                       customer.meta_data?.find(m => m.key === 'apoderado_telefono')?.value;
    if (phoneNumber) {
      window.open(`tel:${phoneNumber}`);
    }
    onPhoneClose();
  };

  // Función para abrir dialog de confirmación de reporte
  const handleSendPaymentReport = () => {
    onReportOpen();
  };

  // Función para confirmar y enviar reporte de pagos
  const handleConfirmSendReport = async () => {
    onReportClose();
    setLoadingSendReport(true);
    try {
      const result = await sendPaymentReport(customer.id);
      if (result.success) {
        toast({
          title: "Reporte Enviado",
          description: `El reporte de pagos ha sido enviado exitosamente a ${customer.email}`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        throw new Error(result.message || "Error al enviar reporte");
      }
    } catch (error) {
      toast({
        title: "Error al Enviar Reporte",
        description: error.message || "No se pudo enviar el reporte de pagos. Inténtalo nuevamente.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingSendReport(false);
    }
  };


  // Función para abrir modal de edición
  const handleEditCustomer = () => {
    if (customer) {
      setEditModalOpen(true);
      
      // Llenar el formulario con los datos del cliente
      setValue('first_name', customer.first_name || '');
      setValue('last_name', customer.last_name || '');
      setValue('email', customer.email || '');
      setValue('username', customer.username || '');
      
      // Obtener el grupo actual del cliente
      const currentGroup = customer.meta_data?.find(m => m.key === 'group_name')?.value || 
                           customer.meta_data?.find(m => m.key === 'grupo')?.value || '';
      setValue('group', currentGroup);
      
      // Obtener la Mensualidad actual del cliente
      const currentSubscription = customer.meta_data?.find(m => m.key === 'suscription_name')?.value || '';
      setValue('suscription', currentSubscription);

      // Rol actual
      setValue('role', customer.role || 'customer');
    }
  };

  // Función para actualizar usuario
  const handleUpdateCustomer = async (data) => {
    setEditLoading(true);
    try {
      // Validar contraseñas si se quieren cambiar
      if (showPasswordFields) {
        if (!data.new_password || !data.confirm_password) {
          toast({
            title: "Error de validación",
            description: "Debes completar ambos campos de contraseña",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setEditLoading(false);
          return;
        }

        if (data.new_password !== data.confirm_password) {
          toast({
            title: "Error de validación",
            description: "Las contraseñas no coinciden",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setEditLoading(false);
          return;
        }

        if (data.new_password.length < 6) {
          toast({
            title: "Error de validación",
            description: "La contraseña debe tener al menos 6 caracteres",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setEditLoading(false);
          return;
        }
      }

      const updateData = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        username: data.username,
        billing: {
          email: data.email,
        },
        meta_data: [
          { key: 'group_name', value: data.group || '' },
          { key: 'grupo', value: data.group || '' },
          { key: 'apoderado_email', value: data.email },
          ...(data.suscription ? [{ key: 'suscription_name', value: data.suscription }] : [])
        ]
      };

      // Agregar contraseña solo si se especificó
      if (showPasswordFields && data.new_password) {
        updateData.password = data.new_password;
      }

      // Cambio de rol (solo admin)
      if (isAdmin && data.role && data.role !== customer.role) {
        try {
          await updateAdminUser(customer.id, { role: data.role });
        } catch (roleErr) {
          toast({ title: 'Advertencia', description: 'Datos actualizados pero no se pudo cambiar el rol.', status: 'warning', duration: 4000, isClosable: true });
        }
      }

      const result = await updateCustomer(customer.id, updateData);
      
      if (result.success) {
        let message = "Usuario actualizado exitosamente en todos los sistemas";
        
        // Mostrar detalles específicos si hay resultados parciales
        if (result.woocommerce?.success && result.datofyApi?.success) {
          message = showPasswordFields
            ? "Usuario y contraseña actualizados correctamente"
            : "Usuario actualizado correctamente";
        } else if (result.woocommerce?.success && !result.datofyApi?.success) {
          message = "Usuario actualizado, pero hubo un problema al sincronizar";
        }

        toast({
          title: "Usuario actualizado",
          description: message,
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        setEditModalOpen(false);
        setShowPasswordFields(false);
        reset();
        await fetchCustomer(); // Refrescar datos del perfil
      } else {
        // Mostrar errores específicos de cada sistema
        let errorMessage = result.message || "No se pudo actualizar el usuario.";
        
        if (result.woocommerce?.success === false) {
          errorMessage = "Error al actualizar el usuario: " + (result.woocommerce.error || "Error desconocido");
        } else if (result.datofyApi?.success === false) {
          errorMessage = "Error en Datofy API: " + (result.datofyApi.message || "Error desconocido");
        }

        toast({
          title: "Error al actualizar",
          description: errorMessage,
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      }
    } catch (error) {
      logger.error('Error updating customer:', error);
      toast({
        title: "Error",
        description: "Ocurrió un error al actualizar el usuario.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setEditLoading(false);
    }
  };

  // Función para cancelar edición
  const handleCancelEdit = () => {
    setEditModalOpen(false);
    setShowPasswordFields(false);
    reset();
  };

  // Cabecera V1: banner degradado + tarjeta solapada
  const ModernUserHeader = () => {
    if (!customer || !customer.id) {
      return null;
    }

    const fullName = `${customer.first_name || ''} ${customer.last_name || ''}`.trim() || 'Sin nombre';
    const group = customer.meta_data?.find(m => m.key === 'group_name')?.value;
    const groupLabel = group ? codeToDisplayLabel(normalizeCourseName(group)) : null;
    const hasAvatarMeta = customer.meta_data?.some(m => m.key === 'avatar_url' && m.value);
    const avatarSrc = hasAvatarMeta
      ? `${process.env.REACT_APP_SURVEY_API_URL}/api/users/${customer.username}/avatar-image`
      : null;
    const initials = getInitials(fullName);
    const avatarGradient = AVATAR_GRADIENTS[(customer.id || 0) % AVATAR_GRADIENTS.length];
    const pendingOrders = ordersData.filter(o => o.status === 'pending').length;
    const suscriptionName = customer.meta_data?.find(m => m.key === 'suscription_name')?.value;

    return (
      <>
        {/* ── Banner ── */}
        <Box
          h={{ base: "100px", md: "160px" }}
          bgGradient="linear(130deg, #E8431A 0%, #C83510 45%, #9B2E0F 100%)"
          position="relative"
          overflow="hidden"
        >
          <Box position="absolute" right="-60px" top="-80px" w="340px" h="340px" borderRadius="50%" bg="rgba(255,255,255,0.08)" />
          <Box position="absolute" left="30%" bottom="-100px" w="260px" h="260px" borderRadius="50%" bg="rgba(255,255,255,0.05)" />
          {groupLabel && (
            <Box
              position="absolute"
              top={{ base: "auto", md: "20px" }}
              bottom={{ base: "12px", md: "auto" }}
              right={{ base: "16px", md: "28px" }}
              bg="rgba(255,255,255,0.15)" border="1px solid rgba(255,255,255,0.25)"
              borderRadius="999px" px={{ base: "12px", md: "14px" }} py={{ base: "5px", md: "6px" }}
              color="white" fontSize={{ base: "11.5px", md: "13px" }} fontWeight="700"
            >
              {groupLabel} · {new Date().getFullYear()}
            </Box>
          )}
          <Text
            display={{ base: "none", md: "block" }}
            position="absolute" bottom="22px" left="28px"
            fontSize="12px" fontWeight="700"
            color="rgba(255,255,255,0.6)" letterSpacing="0.06em" textTransform="uppercase"
          >
            RUT {customer.username}
            {customer.date_created
              ? ` · Ingreso ${new Intl.DateTimeFormat('es-CL', { month: 'long', year: 'numeric' }).format(new Date(customer.date_created))}`
              : ''}
          </Text>
        </Box>

        {/* ── Tarjeta de perfil (solapa el banner) ── */}
        <Box px={{ base: "16px", md: "28px" }} mt={{ base: "-36px", md: "-62px" }} position="relative" zIndex={2}>
          <Box
            bg="white" border="1px solid" borderColor="cream.line"
            borderRadius={{ base: "20px", md: "28px" }}
            boxShadow="0 4px 8px rgba(54,38,22,.05), 0 28px 60px -22px rgba(70,45,22,.28)"
            p={{ base: "18px 18px 16px", md: "24px 28px" }}
          >
            <Flex align="flex-start" gap={{ base: 0, md: "22px" }} direction={{ base: "column", md: "row" }}>

              {/* Avatar */}
              <Box position="relative" flexShrink={0}
                mt={{ base: "-20px", md: "-16px" }}
                mr={{ base: "0", md: "22px" }}
                mb={{ base: "14px", md: "0" }}
                mx={{ base: "auto", md: "0" }}
              >
                <input
                  ref={avatarInputRef}
                  type="file"
                  accept="image/jpeg,image/jpg,image/png,image/webp"
                  style={{ display: 'none' }}
                  onChange={handleAvatarUpload}
                />
                {/* Avatar con foto o gradiente */}
                {avatarSrc ? (
                  <ZoomableAvatar
                    src={avatarSrc}
                    name={fullName}
                    caption={{ firstName: customer.first_name, lastName: customer.last_name, rut: customer.username, course: groupLabel }}
                    w={{ base: "72px", md: "88px" }} h={{ base: "72px", md: "88px" }}
                    borderRadius="50%"
                    border="4px solid white"
                    boxShadow="0 10px 24px -8px rgba(232,64,26,.55)"
                  />
                ) : (
                  <Flex
                    w={{ base: "72px", md: "88px" }} h={{ base: "72px", md: "88px" }}
                    borderRadius="50%"
                    bgGradient={avatarGradient}
                    align="center" justify="center"
                    fontWeight="800" color="white"
                    fontSize={{ base: "24px", md: "30px" }}
                    border="4px solid white"
                    boxShadow="0 10px 24px -8px rgba(232,64,26,.55)"
                    flexShrink={0}
                  >
                    {initials}
                  </Flex>
                )}
                <Tooltip label="Cambiar foto de perfil">
                  <Box
                    position="absolute" bottom="-2px" right="-2px"
                    bg="coral.500" borderRadius="full"
                    w="26px" h="26px"
                    display="flex" alignItems="center" justifyContent="center"
                    cursor="pointer" border="2px solid white"
                    onClick={() => !uploadingAvatar && avatarInputRef.current?.click()}
                    _hover={{ bg: 'coral.600' }}
                    transition="background 0.2s"
                  >
                    {uploadingAvatar
                      ? <Spinner size="xs" color="white" />
                      : <Icon as={FiCamera} color="white" boxSize="12px" />}
                  </Box>
                </Tooltip>
              </Box>

              {/* Info: nombre + meta + chips */}
              <Box flex={1} minW={0} mt="4px" textAlign={{ base: "center", md: "left" }} w={{ base: "full", md: "auto" }}>
                <Text fontSize={{ base: "18px", md: "22px" }} fontWeight="800" letterSpacing="-0.025em" lineHeight="1.15" color="ink.900" fontFamily="jakarta">
                  {fullName}
                </Text>
                <HStack mt="7px" spacing="14px" flexWrap="wrap" justify={{ base: "center", md: "flex-start" }}>
                  <HStack spacing="5px">
                    <Icon as={FiUser} boxSize="14px" color="ink.400" />
                    <Text fontSize="13.5px" color="ink.700" fontWeight="600" fontFamily="jakarta">RUT {customer.username}</Text>
                  </HStack>
                  {customer.email && (
                    <HStack spacing="5px">
                      <Icon as={FiMail} boxSize="14px" color="ink.400" />
                      <Text fontSize="13.5px" color="ink.700" fontWeight="600" fontFamily="jakarta" noOfLines={1}>{customer.email}</Text>
                    </HStack>
                  )}
                  {(customer.meta_data?.find(m => m.key === 'apoderado_telefono')?.value || customer.meta_data?.find(m => m.key === 'telefono')?.value) && (
                    <HStack spacing="5px">
                      <Icon as={FiPhone} boxSize="14px" color="ink.400" />
                      <Text fontSize="13.5px" color="ink.700" fontWeight="600" fontFamily="jakarta">
                        {customer.meta_data?.find(m => m.key === 'apoderado_telefono')?.value || customer.meta_data?.find(m => m.key === 'telefono')?.value}
                      </Text>
                    </HStack>
                  )}
                </HStack>
                <HStack mt="12px" spacing="8px" flexWrap="wrap" justify={{ base: "center", md: "flex-start" }}>
                  {(() => {
                    const { key, label } = getRoleDisplay(customer.role, isAdmin);
                    const icon = { customer: '● ', becado: '🎓 ', cobranza: '💰 ', subscriber: '⏸ ' }[key];
                    const tone = { customer: 'mint', becado: 'lav', cobranza: 'rose', subscriber: 'butter' }[key];
                    return (
                      <Box as="span" px="11px" py="4px" borderRadius="999px" fontSize="12px" fontWeight="700"
                        bg={`${tone}.bg`} color={`${tone}.ink`}>
                        {icon}{label}
                      </Box>
                    );
                  })()}
                  {groupLabel && (
                    <Box as="span" px="11px" py="4px" borderRadius="999px" fontSize="12px" fontWeight="700" bg="sky.bg" color="sky.ink">
                      {groupLabel}
                    </Box>
                  )}
                  {suscriptionName && (
                    <Box as="span" px="11px" py="4px" borderRadius="999px" fontSize="12px" fontWeight="700" bg="mint.bg" color="mint.ink">
                      {suscriptionName}
                    </Box>
                  )}
                </HStack>
              </Box>

              {/* Stats rápidas — ocultas en tablet (md/lg), visibles en mobile y desktop (xl+) */}
              <HStack
                display={{ base: "flex", md: "none", xl: "flex" }}
                spacing={{ base: "0", md: "18px" }}
                align="flex-start"
                pl={{ base: "0", md: "24px" }}
                pt={{ base: "14px", md: "0" }}
                mt={{ base: "14px", md: "4px" }}
                borderLeft={{ base: "none", md: "1px solid" }}
                borderTop={{ base: "1px solid", md: "none" }}
                borderColor="cream.line"
                w={{ base: "full", md: "auto" }}
                justify={{ base: "space-around", md: "flex-start" }}
                flexShrink={0}
              >
                {surveysModule && (
                  <VStack spacing="4px" textAlign="center" minW="60px">
                    <Text fontSize="24px" fontWeight="800" letterSpacing="-0.02em" lineHeight="1" fontFamily="jakarta">{filteredSurveys.length}</Text>
                    <Text fontSize="12px" color="ink.400" fontWeight="600" fontFamily="jakarta" lineHeight="1.3">Fichas</Text>
                  </VStack>
                )}
                {showPayments && (
                  <VStack spacing="4px" textAlign="center" minW="60px">
                    <Text fontSize="24px" fontWeight="800" letterSpacing="-0.02em" lineHeight="1" fontFamily="jakarta"
                      color={pendingOrders > 0 ? 'butter.ink' : 'mint.ink'}>
                      {pendingOrders}
                    </Text>
                    <Text fontSize="12px" color="ink.400" fontWeight="600" fontFamily="jakarta" lineHeight="1.3">Pagos<br/>pend.</Text>
                  </VStack>
                )}
                {filesModule && (
                  <VStack spacing="4px" textAlign="center" minW="60px">
                    <Text fontSize="24px" fontWeight="800" letterSpacing="-0.02em" lineHeight="1" fontFamily="jakarta">{userFiles.length}</Text>
                    <Text fontSize="12px" color="ink.400" fontWeight="600" fontFamily="jakarta" lineHeight="1.3">Archivos</Text>
                  </VStack>
                )}
              </HStack>

              {/* Botones de acción — mobile: 3 botones en fila */}
              <Flex
                display={{ base: "flex", md: "none" }}
                gap="8px" w="full"
                pt="12px" mt="4px"
                borderTop="1px solid" borderColor="cream.line"
              >
                {moduleStatus[MODULES.SURVEYS] && (
                  <Button flex={1} size="sm" bg="coral.500" color="white" fontWeight="700"
                    borderRadius="12px" _hover={{ bg: 'coral.600' }}
                    leftIcon={<Icon as={FaPenFancy} boxSize="13px" />}
                    onClick={() => setShowSurveyModal(true)}>
                    Ficha
                  </Button>
                )}
                {hasAgenda && authUser?.id && (
                  <Button flex={1} size="sm" variant="outline" borderColor="cream.line" color="ink.700"
                    borderRadius="12px" fontWeight="700"
                    _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                    leftIcon={<Icon as={FiCalendar} boxSize="13px" />}
                    onClick={() => {
                      const url = `${window.location.origin}/#/public/reservar-hora/${authUser.id}?student_rut=${encodeURIComponent(customer.username)}`;
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }}>
                    Agendar
                  </Button>
                )}
                {showSubscriptions && (
                  <Button flex={1} size="sm" variant="outline" borderColor="cream.line" color="ink.700"
                    borderRadius="12px" fontWeight="700"
                    _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                    leftIcon={<Icon as={FiCreditCard} boxSize="13px" />}
                    onClick={() => setShowOrderCreate(true)}>
                    Pago
                  </Button>
                )}
              </Flex>

              {/* Botones de acción — desktop: columnas */}
              <VStack
                display={{ base: "none", md: "flex" }}
                spacing="9px" align="stretch"
                pl="22px" borderLeft="1px solid" borderColor="cream.line"
                mt="4px" flexShrink={0} minW="210px"
              >
                {/* Formularios (menú dropdown) */}
                {moduleStatus[MODULES.SURVEYS] && availableFormCategories.length > 0 ? (
                  <Menu>
                    <MenuButton
                      as={Button}
                      size="sm"
                      bg="coral.500" color="white" fontWeight="700"
                      borderRadius="11px"
                      _hover={{ bg: 'coral.600' }}
                      _active={{ bg: 'coral.700' }}
                      leftIcon={<Icon as={FaPenFancy} boxSize="13px" />}
                      textAlign="left"
                    >
                      Nueva ficha de atención
                    </MenuButton>
                    <Portal>
                      <MenuList zIndex={99999} fontSize="13px" minW="220px" maxH="400px" overflowY="auto">
                        {availableFormCategories.map(({ category, count, icon }) => {
                          const catForms = availableSurveys.filter(s =>
                            s.category === category && canUserAccessCategory(userRole, s.category)
                          );
                          return (
                            <Box key={category}>
                              <Box px={3} py={2} bg="cream.bg2" borderBottom="1px" borderColor="cream.line">
                                <HStack justify="space-between">
                                  <HStack spacing={2}>
                                    <Icon as={icon} boxSize={4} color="ink.400" />
                                    <Text fontSize="xs" fontWeight="700" color="ink.700">{getCategoryDisplayName(category)}</Text>
                                  </HStack>
                                  <Box as="span" px="6px" py="2px" borderRadius="999px" fontSize="11px" fontWeight="700" bg="coral.soft" color="coral.700">{count}</Box>
                                </HStack>
                              </Box>
                              {catForms.map(s => (
                                <MenuItem key={s.id} fontSize="13px" pl={8}
                                  onClick={() => {
                                    setModalDirectAccessMode({ id: s.id, slug: s.slug });
                                    setSelectedSurveyCategory(category);
                                    if ((category === 'casos' || category === 'Casos') && canUserAccessCategory(userRole, 'casos')) {
                                      setModalOpenedFromCases(true);
                                      setActiveTab(getCasesTabIndex());
                                    } else {
                                      setActiveTab(0);
                                    }
                                    setShowSurveyModal(true);
                                  }}
                                >
                                  <Box>
                                    <Text fontWeight="600">{s.name}</Text>
                                    {s.description && <Text fontSize="11px" color="ink.400" noOfLines={1}>{s.description}</Text>}
                                  </Box>
                                </MenuItem>
                              ))}
                              {catForms.length === 0 && (
                                <MenuItem fontSize="13px" pl={8} color="ink.400"
                                  onClick={() => { setModalDirectAccessMode(null); setShowSurveyModal(true); }}>
                                  Ver todos los disponibles
                                </MenuItem>
                              )}
                            </Box>
                          );
                        })}
                        <MenuDivider />
                        <MenuItem icon={<Icon as={FiGrid} />} fontSize="13px" fontWeight="700"
                          onClick={() => { setModalDirectAccessMode(null); setShowSurveyModal(true); }}>
                          Ver todos los formularios
                        </MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>
                ) : moduleStatus[MODULES.SURVEYS] && (
                  <Button size="sm" bg="coral.500" color="white" fontWeight="700" borderRadius="11px"
                    _hover={{ bg: 'coral.600' }} leftIcon={<Icon as={FaPenFancy} boxSize="13px" />}
                    onClick={() => setShowSurveyModal(true)} isLoading={loadingAvailableSurveys}>
                    Nueva ficha
                  </Button>
                )}

                {/* Fila: Agendar + Cobro */}
                {(hasAgenda || showSubscriptions) && (
                  <HStack spacing="8px">
                    {hasAgenda && authUser?.id && (
                      <Button size="sm" flex={1} variant="outline" borderColor="cream.line" color="ink.700"
                        borderRadius="11px" fontWeight="700" fontFamily="jakarta"
                        _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                        leftIcon={<Icon as={FiCalendar} boxSize="13px" />}
                        onClick={() => {
                          const url = `${window.location.origin}/#/public/reservar-hora/${authUser.id}?student_rut=${encodeURIComponent(customer.username)}`;
                          window.open(url, '_blank', 'noopener,noreferrer');
                        }}>
                        Agendar
                      </Button>
                    )}
                    {showSubscriptions && (
                      <Button size="sm" flex={1} variant="outline" borderColor="cream.line" color="ink.700"
                        borderRadius="11px" fontWeight="700" fontFamily="jakarta"
                        _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                        leftIcon={<Icon as={FiCreditCard} boxSize="13px" />}
                        onClick={() => setShowOrderCreate(true)}>
                        Cobro
                      </Button>
                    )}
                  </HStack>
                )}

                {/* Fila: Email + Editar */}
                <HStack spacing="8px">
                  <Button size="sm" flex={1} variant="outline" borderColor="cream.line" color="ink.700"
                    borderRadius="11px" fontWeight="700" fontFamily="jakarta"
                    _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                    leftIcon={<Icon as={FiMail} boxSize="13px" />}
                    onClick={onEmailOpen}>
                    Email
                  </Button>
                  <Button size="sm" flex={1} variant="outline" borderColor="cream.line" color="ink.700"
                    borderRadius="11px" fontWeight="700" fontFamily="jakarta"
                    _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                    leftIcon={<Icon as={FiEdit3} boxSize="13px" />}
                    onClick={handleEditCustomer}>
                    Editar
                  </Button>
                </HStack>

                {/* Fila extra: Reporte (solo admin) */}
                {showSubscriptions && ordersData?.length > 0 && (
                  <HStack spacing="8px">
                    <Button size="sm" flex={1} variant="outline" borderColor="cream.line" color="ink.700"
                      borderRadius="11px" fontWeight="700" fontFamily="jakarta"
                      _hover={{ borderColor: 'coral.500', color: 'coral.700' }}
                      leftIcon={<Icon as={FiDownload} boxSize="13px" />}
                      onClick={handleSendPaymentReport} isLoading={loadingSendReport} loadingText="...">
                      Reporte
                    </Button>
                  </HStack>
                )}
              </VStack>

            </Flex>
          </Box>
        </Box>
      </>
    );
  };


  // Área Principal - Contenido con Tabs (columna única)
  const MainContent = () => (
    <VStack spacing={4} align="stretch" w="100%">
      <Card bg={bgCard} borderRadius="16px">
        <Tabs index={activeTab} onChange={(index) => {
          setActiveTab(index);
          localStorage.setItem('profile-current-tab-v2', JSON.stringify(index));
        }}>
          <TabList
            borderBottom="1px" borderColor={borderColor}
            px={{ base: 3, md: 6 }} pt={4}
            overflowX="auto" overflowY="hidden"
            sx={{ scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}
            whiteSpace="nowrap"
          >
            <Tab fontSize="sm">Antecedentes</Tab>
            {moduleStatus[MODULES.SURVEYS] && <Tab fontSize="sm">Fichas</Tab>}
            {hasAgenda && <Tab fontSize="sm">Agenda</Tab>}
            {showPayments && <Tab fontSize="sm">Pagos</Tab>}
            {moduleStatus[MODULES.FILES] && ['administrador', 'profesor', 'teacher'].includes(userRole) && <Tab fontSize="sm">Archivos</Tab>}
            {moduleStatus[MODULES.SURVEYS] && canUserAccessCategory(userRole, 'casos') && <Tab fontSize="sm">Casos</Tab>}
            {userRole === 'administrador' && <Tab fontSize="sm">Actividad</Tab>}
            {['administrador', 'inspector'].includes(userRole) && <Tab fontSize="sm">Accesos QR</Tab>}
          </TabList>

            <TabPanels>
              {/* Tab Antecedentes */}
              <TabPanel p={0}>
                <AntecedentesTab
                  customer={customer}
                  onUpdate={() => fetchCustomer(true)}
                  hasAgenda={hasAgenda}
                  userSurveys={userSurveys}
                />
              </TabPanel>

              {/* Tab Fichas - Vista de carpetas (drive) o lista, con panel de previsualización */}
              {moduleStatus[MODULES.SURVEYS] && (
                <TabPanel p={0}>
                  <FichasTab
                    customer={customer}
                    surveys={filteredSurveys}
                    categories={surveyCategoryList}
                    updateSurveyResponses={updateSurveyResponses}
                    availableSurveys={availableSurveys}
                  />
                </TabPanel>
              )}

              {/* Tab Agenda - Citas agendadas con este alumno */}
              {hasAgenda && (
                <TabPanel p={0}>
                  <StudentAgendaTab customer={customer} />
                </TabPanel>
              )}

              {/* Tab Pagos - Componente Original */}
              {showPayments && (
                <TabPanel p={0}>
                  <Payments
                    customer={customer}
                    ordersData={ordersData}
                    onOrderClick={handleOrderClick}
                    onNewOrder={() => setShowOrderCreate(true)}
                    onRefresh={handlePaymentsRefresh}
                    isLoading={paymentsLoading}
                  />
                </TabPanel>
              )}

              {/* Tab Archivos */}
              {moduleStatus[MODULES.FILES] && ['administrador', 'profesor', 'teacher'].includes(userRole) && (
                <TabPanel p={0}>
                  <Files
                    customer={customer}
                    data={{ success: true, data: userFiles || [] }}
                    title="Archivos y Documentos"
                    onFileClick={handleFileClick}
                    onRefresh={handleDataRefresh}
                    excludeCategories={userRole !== 'administrador' ? ['becas'] : []}
                  />
                </TabPanel>
              )}

              {/* Tab Casos - Sistema de gestión de casos */}
              {moduleStatus[MODULES.SURVEYS] && canUserAccessCategory(userRole, 'casos') && (
                <TabPanel p={0}>
                  <Box p={6}>
                  {!selectedCase ? (
                    // Vista de lista de casos
                    <CasosListView
                      customer={customer}
                      onSelectCaso={setSelectedCase}
                      onCreateCaso={() => setShowCasoCreateModal(true)}
                    />
                  ) : (
                    // Vista de detalle de caso específico
                    <CasoDetailView
                      caso={selectedCase}
                      customer={customer}
                      onBack={() => setSelectedCase(null)}
                      onCasoUpdated={() => {
                        // Refresh casos list if needed
                        setSelectedCase(null);
                      }}
                      availableCaseForms={availableCaseForms}
                      onAddFicha={(category, formId, casoId) => {
                        // Marcar que el modal se abrió desde la pestaña Casos
                        setModalOpenedFromCases(true);

                        // Establecer el caso específico para asociar la ficha
                        setSelectedFormForCase({ formId, casoId });

                        // Establecer modo de acceso directo a casos
                        setModalDirectAccessMode(formId ? null : 'casos'); // Si hay formId específico, mostrar lista; si no, acceso directo

                        // Abrir modal de formularios con acceso directo a casos
                        setShowSurveyModal(true);
                      }}
                    />
                  )}
                  </Box>
                </TabPanel>
              )}

              {/* Tab Actividad Reciente - Solo para administradores */}
              {userRole === 'administrador' && (
                <TabPanel p={0}>
                  <Box p={6} fontFamily="jakarta">
                    <Box
                      bg="white" border="1px solid" borderColor="cream.line" borderRadius="20px"
                      p={{ base: 4, md: 6 }} boxShadow="0 2px 12px -4px rgba(35,30,26,.08)"
                    >
                      <HStack justify="space-between" align="center" mb={4}>
                        <HStack spacing={2}>
                          <Flex w="34px" h="34px" borderRadius="10px" bg="mint.bg" align="center" justify="center">
                            <Icon as={FiActivity} color="mint.ink" boxSize={4} />
                          </Flex>
                          <Text fontWeight="800" fontSize="15px" color="ink.900">
                            Actividad reciente
                          </Text>
                        </HStack>
                        <HStack spacing={1.5}>
                          <Icon as={FiClock} color="ink.400" boxSize={3.5} />
                          <Text fontSize="12px" color="ink.400" fontWeight="500">
                            Última: {ordersData.length > 0
                              ? new Date(ordersData[0]?.date_created).toLocaleDateString('es-CL')
                              : 'N/A'
                            }
                          </Text>
                        </HStack>
                      </HStack>

                      <VStack spacing={2} align="stretch" maxH="600px" overflowY="auto">
                        {ordersData.slice(0, 20).map((order) => {
                          const statusCfg = order.status === 'completed'
                            ? { dot: '#1E7A4E', pastel: 'mint' }
                            : order.status === 'pending'
                            ? { dot: '#92400E', pastel: 'butter' }
                            : { dot: '#DC2626', pastel: 'rose' };
                          return (
                            <HStack key={order.id} spacing={3} p={3} borderRadius="14px"
                              border="1px solid" borderColor="cream.line"
                              _hover={{ bg: 'coral.tint' }} transition="background .13s">
                              <Box w="10px" h="10px" borderRadius="full" bg={statusCfg.dot} flexShrink={0} />
                              <VStack spacing="2px" align="flex-start" flex={1} minW={0}>
                                <Text fontSize="13.5px" fontWeight="700" color="ink.900" noOfLines={1}>
                                  {order.meta_data?.find(m => m.key === 'concepto')?.value || 'Pago'}
                                </Text>
                                <Text fontSize="11.5px" color="ink.400" fontWeight="500">
                                  {new Date(order.date_created).toLocaleDateString('es-CL', {
                                    day: '2-digit', month: '2-digit', year: 'numeric'
                                  })} · {new Date(order.date_created).toLocaleTimeString('es-CL', {
                                    hour: '2-digit', minute: '2-digit'
                                  })}
                                </Text>
                              </VStack>
                              <Box as="span" px="10px" py="3px" borderRadius="999px" fontSize="12.5px" fontWeight="800"
                                bg={`${statusCfg.pastel}.bg`} color={`${statusCfg.pastel}.ink`} flexShrink={0}>
                                ${order.total}
                              </Box>
                              <IconButton
                                icon={<Icon as={FiEye} />}
                                size="xs" variant="ghost" color="ink.400"
                                _hover={{ color: 'coral.500', bg: 'coral.tint' }}
                                aria-label="Ver detalle"
                                onClick={() => handleOrderClick(order)}
                              />
                            </HStack>
                          );
                        })}

                        {ordersData.length === 0 && (
                          <Text fontSize="13.5px" color="ink.400" textAlign="center" py={8}>
                            Sin actividad reciente
                          </Text>
                        )}
                      </VStack>
                    </Box>
                  </Box>
                </TabPanel>
              )}

              {/* Tab Accesos QR - Administradores e inspectores */}
              {['administrador', 'inspector'].includes(userRole) && (
                <TabPanel p={0}>
                  <Box p={6}>
                    <VStack spacing={5} align="stretch">
                      <QRCard customer={customer} />
                      <Grid templateColumns={{ base: '1fr', lg: '360px 1fr' }} gap={5} alignItems="start">
                        <StudentStatusCard customer={customer} />
                        <Box
                          bg="white" border="1px solid" borderColor="cream.line" borderRadius="20px"
                          p={{ base: 4, md: 6 }} boxShadow="0 2px 12px -4px rgba(35,30,26,.08)"
                          fontFamily="jakarta"
                        >
                          <Text fontWeight="800" fontSize="15px" color="ink.900" mb={4}>
                            Historial de accesos
                          </Text>
                          <StudentAccessHistory
                            student={{
                              username:   customer?.username,
                              id:         customer?.id,
                              first_name: customer?.first_name,
                              last_name:  customer?.last_name,
                            }}
                          />
                        </Box>
                      </Grid>
                    </VStack>
                  </Box>
                </TabPanel>
              )}
            </TabPanels>
          </Tabs>
        </Card>
    </VStack>
  );


  // Componente principal con todas las condiciones
  return (
    <>
      {loading && (
        <Box bg={bgMain} minH="100vh" display="flex" alignItems="center" justifyContent="center">
          <Text>Cargando perfil...</Text>
        </Box>
      )}

      {error && (
        <Box bg={bgMain} minH="100vh" display="flex" alignItems="center" justifyContent="center">
          <Text color="red.500">{error}</Text>
        </Box>
      )}

      {/* Mostrar loading si customer no está cargado */}
      {(!customer || !customer.id) && (
        <Box bg={bgMain} minH="100vh" pt={{ base: "80px", md: "80px" }} display="flex" alignItems="center" justifyContent="center">
          <VStack spacing={4}>
            <Text fontSize="lg" color={textColor}>Cargando perfil...</Text>
          </VStack>
        </Box>
      )}

      {!loading && !error && customer && customer.id && (
    <Box bg="cream.bg" minH="100vh">
      {/* Backbar (mobile) / Breadcrumb (desktop) */}
      <Flex
        h={{ base: "50px", md: "auto" }}
        align="center"
        px={{ base: "16px", md: "28px" }}
        py={{ base: "0", md: "12px" }}
        bg={{ base: "white", md: "transparent" }}
        borderBottom={{ base: "1px solid", md: "none" }}
        borderColor="cream.line"
        gap="8px"
      >
        {/* Mobile: back button */}
        <Button
          display={{ base: "flex", md: "none" }}
          variant="ghost" size="sm" px="0" gap="4px"
          color="coral.700" fontWeight="700" fontSize="14px" fontFamily="jakarta"
          leftIcon={<Icon as={FiChevronLeft} boxSize="20px" strokeWidth="2.5" />}
          onClick={() => history.push('/admin/suscriptions')}
          _hover={{ bg: "transparent" }}
        >
          Alumnos
        </Button>
        {/* Mobile: name centered */}
        <Text
          display={{ base: "block", md: "none" }}
          flex={1} textAlign="center"
          fontSize="14.5px" fontWeight="700" color="ink.900" fontFamily="jakarta"
          noOfLines={1}
        >
          {`${customer.first_name || ''} ${customer.last_name || ''}`.trim() || customer.username}
        </Text>
        {/* Mobile: more menu */}
        <Menu>
          <MenuButton
            as={IconButton}
            display={{ base: "flex", md: "none" }}
            icon={<Icon as={FiSettings} boxSize="18px" />}
            variant="ghost" size="sm"
            color="ink.700"
            borderRadius="10px"
            bg="cream.bg2"
            _hover={{ bg: "cream.line" }}
          />
          <Portal>
            <MenuList zIndex={9999} fontSize="13px">
              <MenuItem icon={<Icon as={FiEdit3} boxSize="14px" />} fontWeight="600" onClick={handleEditCustomer}>Editar alumno</MenuItem>
              <MenuItem icon={<Icon as={FiMail} boxSize="14px" />} fontWeight="600" onClick={onEmailOpen}>Enviar email</MenuItem>
              {showSubscriptions && <MenuItem icon={<Icon as={FiCreditCard} boxSize="14px" />} fontWeight="600" onClick={() => setShowSubscriptionChange(true)}>Cambiar mensualidad</MenuItem>}
            </MenuList>
          </Portal>
        </Menu>
        {/* Desktop: breadcrumb */}
        <HStack display={{ base: "none", md: "flex" }} spacing="6px" fontSize="13px" fontWeight="600" fontFamily="jakarta" color="ink.400">
          <Box as="span" cursor="pointer" color="coral.500" _hover={{ color: 'coral.700', textDecoration: 'underline' }} onClick={() => history.push('/admin/suscriptions')}>Alumnos</Box>
          <Icon as={FiChevronRight} boxSize="14px" />
          <Box as="span" color="ink.700">{`${customer.first_name || ''} ${customer.last_name || ''}`.trim() || customer.username}</Box>
        </HStack>
      </Flex>

      {/* Header (banner + card).
          ModernUserHeader/MainContent se declaran dentro de Profile: si se usaran
          como <Componente />, cada re-render de Profile crearía un tipo nuevo y
          React desmontaría todo el subárbol (cerrando modales abiertos, ej. Ver
          ficha en FichasTab). Se invocan como funciones de render (sin hooks). */}
      {ModernUserHeader()}


      {/* Área Principal - Contenido con Tabs */}
      <Box mt={{ base: "14px", md: "22px" }} px={{ base: "0", md: "28px" }} pb={{ base: "100px", md: "28px" }}>
        {MainContent()}
      </Box>

      {/* Modales Originales */}
      {selectedOrder && (
        <ModalOrderEdit
          isOpen={showOrderModal}
          onClose={handleCloseModals}
          order={selectedOrder}
          customer={customer}
          onUpdate={handlePaymentsRefresh}
        />
      )}

      {selectedFile && (
        <DocumentViewerModal
          isOpen={showFileModal}
          onClose={handleCloseModals}
          fileData={selectedFile}
        />
      )}

      {/* Modal de detalle de caso */}
      <ModalSurveyResponse
        isOpen={showCaseModal}
        onClose={() => {
          setShowCaseModal(false);
          setSelectedCase(null);
          setCaseModalData(null);
        }}
        customer={customer}
        data={caseModalData}
        onSurveyDeleted={updateSurveyResponses}
      />

      {/* Modales de Acciones */}
      <Modal isOpen={showOrderCreate} onClose={() => setShowOrderCreate(false)} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Generar Nuevo Cobro</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersOrderCreate
              customers={[customer]}
              onOrderCreated={handleOrderActionComplete}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={showOrderDelete} onClose={() => setShowOrderDelete(false)} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Eliminar Cobros</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersOrderDelete
              customers={[customer]}
              onOrderDeleted={handleOrderActionComplete}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={showTicketCreate} onClose={() => setShowTicketCreate(false)} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crear Entradas</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersTicketCreate
              customers={[customer]}
              categoryId={'tickets'}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={showGroupChange} onClose={() => setShowGroupChange(false)} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cambiar Grupo de Usuario</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersGroup
              customers={[customer]}
              groupList={groups}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={showSubscriptionChange} onClose={() => setShowSubscriptionChange(false)} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cambiar Mensualidad de Usuario</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BatchUsersSubscription
              customers={[customer]}
              onSubscriptionChanged={handleActionComplete}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Modal de Survey - Acceso directo por contexto */}
      <ModalAddSurveyResponse
        isOpen={showSurveyModal}
        onClose={handleSurveyComplete}
        customer={customer}
        updateSurveyResponses={updateSurveyResponses}
        userAuth={customer}
        directAccess={modalDirectAccessMode} // null = mostrar lista, 'casos'/'atencion' = acceso directo
        casoId={selectedFormForCase?.casoId || null}
        preselectedFormId={selectedFormForCase?.formId || null}
      />

      {/* Modal de edición de usuario */}
      <Modal isOpen={editModalOpen} onClose={handleCancelEdit} size="lg">
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(handleUpdateCustomer)}>
            <ModalHeader>Editar Usuario</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl isRequired>
                <FormLabel>RUT</FormLabel>
                <Input
                  {...register("username", { required: "El RUT es requerido" })}
                  onChange={(e) => e.target.value = format(e.target.value, { dots: false })}
                  placeholder="Ejemplo: 12345678-9"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  {...register("email", { 
                    required: "El email es requerido",
                    pattern: { value: /^\S+@\S+$/i, message: "Email inválido" }
                  })}
                  placeholder="email@ejemplo.com"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Nombres</FormLabel>
                <Input
                  {...register("first_name", { required: "Los nombres son requeridos" })}
                  placeholder="Nombres"
                />
              </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel>Apellidos</FormLabel>
                <Input
                  {...register("last_name", { required: "Los apellidos son requeridos" })}
                  placeholder="Apellidos"
                />
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Grupo</FormLabel>
                <Select {...register("group")} placeholder="Seleccione un grupo">
                  <option value="">Sin grupo</option>
                  {groups.map((grupo) => (
                    <option key={grupo.name} value={grupo.name}>
                      {grupo.name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              {moduleStatus[MODULES.SUBSCRIPTIONS] && (
                <FormControl mt={4}>
                  <FormLabel>Mensualidad</FormLabel>
                  <Select {...register("suscription")} placeholder="Seleccione una Mensualidad">
                    <option value="">Sin Mensualidad</option>
                    {products.map((product) => (
                      <option key={product.id} value={product.name}>
                        {product.name} - ${product.price}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}

              {isAdmin && (
                <FormControl mt={4}>
                  <FormLabel>Rol</FormLabel>
                  <Select {...register("role")}>
                    <option value="customer">Activo (customer)</option>
                    <option value="becado">Becado</option>
                    <option value="cobranza">Cobranza</option>
                    <option value="subscriber">Archivado (subscriber)</option>
                  </Select>
                </FormControl>
              )}

              <Divider my={4} />

              <Checkbox
                isChecked={showPasswordFields}
                onChange={(e) => {
                  setShowPasswordFields(e.target.checked);
                  if (!e.target.checked) {
                    setValue('new_password', '');
                    setValue('confirm_password', '');
                    setShowPassword(false);
                    setShowConfirmPassword(false);
                  }
                }}
                colorScheme="purple"
              >
                <HStack spacing={2}>
                  <Icon as={FiLock} />
                  <Text fontWeight="medium">Cambiar contraseña</Text>
                </HStack>
              </Checkbox>

              {showPasswordFields && (
                <VStack spacing={4} mt={4} p={4} bg={useColorModeValue('gray.50', 'gray.700')} borderRadius="md">
                  <FormControl>
                    <FormLabel>Nueva contraseña</FormLabel>
                    <InputGroup>
                      <Input
                        type={showPassword ? "text" : "password"}
                        {...register("new_password", {
                          minLength: { value: 6, message: "La contraseña debe tener al menos 6 caracteres" }
                        })}
                        placeholder="Mínimo 6 caracteres"
                      />
                      <InputRightElement>
                        <IconButton
                          size="sm"
                          variant="ghost"
                          icon={<Icon as={showPassword ? FiEyeOff : FiEye} />}
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        />
                      </InputRightElement>
                    </InputGroup>
                    {errors.new_password && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        {errors.new_password.message}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl>
                    <FormLabel>Confirmar contraseña</FormLabel>
                    <InputGroup>
                      <Input
                        type={showConfirmPassword ? "text" : "password"}
                        {...register("confirm_password", {
                          validate: (value) => {
                            const newPassword = watch('new_password');
                            if (newPassword && value !== newPassword) {
                              return "Las contraseñas no coinciden";
                            }
                            return true;
                          }
                        })}
                        placeholder="Repite la contraseña"
                      />
                      <InputRightElement>
                        <IconButton
                          size="sm"
                          variant="ghost"
                          icon={<Icon as={showConfirmPassword ? FiEyeOff : FiEye} />}
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          aria-label={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        />
                      </InputRightElement>
                    </InputGroup>
                    {errors.confirm_password && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        {errors.confirm_password.message}
                      </Text>
                    )}
                  </FormControl>

                  <Text fontSize="xs" color="gray.500">
                    La contraseña se actualizará en todos los sistemas
                  </Text>
                </VStack>
              )}
            </ModalBody>

            <ModalFooter>
              <Button 
                colorScheme="blue" 
                mr={3} 
                type="submit" 
                isLoading={editLoading}
              >
                Actualizar
              </Button>
              <Button variant="ghost" onClick={handleCancelEdit}>
                Cancelar
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* Dialog de confirmación para email */}
      <AlertDialog
        isOpen={isEmailOpen}
        leastDestructiveRef={cancelRef}
        onClose={onEmailClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Enviar Email
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro de que deseas enviar un email a {customer.email}?
              <br />
              <Text mt={2} fontSize="sm" color={mutedText}>
                Se abrirá tu cliente de email predeterminado.
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onEmailClose}>
                Cancelar
              </Button>
              <Button colorScheme="blue" onClick={handleConfirmEmail} ml={3}>
                Enviar Email
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Dialog de confirmación para teléfono */}
      <AlertDialog
        isOpen={isPhoneOpen}
        leastDestructiveRef={cancelRef}
        onClose={onPhoneClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Realizar Llamada
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro de que deseas llamar al número{' '}
              <Text as="span" fontWeight="bold">
                {customer.meta_data?.find(m => m.key === 'telefono')?.value || 
                 customer.meta_data?.find(m => m.key === 'apoderado_telefono')?.value}
              </Text>
              ?
              <br />
              <Text mt={2} fontSize="sm" color={mutedText}>
                Se abrirá tu aplicación de teléfono predeterminada.
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onPhoneClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" onClick={handleConfirmPhone} ml={3}>
                Llamar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Dialog de confirmación para enviar reporte */}
      <AlertDialog
        isOpen={isReportOpen}
        leastDestructiveRef={cancelRef}
        onClose={onReportClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Enviar Reporte de Pagos
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro de que deseas enviar el reporte completo de pagos a{' '}
              <Text as="span" fontWeight="bold">
                {customer.first_name || ''} {customer.last_name || ''}
              </Text>
              ?
              <br />
              <Text mt={2} fontSize="sm" color={mutedText}>
                El reporte será enviado a: {customer.email || ''}
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onReportClose}>
                Cancelar
              </Button>
              <Button 
                colorScheme="blue" 
                onClick={handleConfirmSendReport} 
                ml={3}
                isLoading={loadingSendReport}
                loadingText="Enviando..."
              >
                Enviar Reporte
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Modal para crear nuevos casos */}
      <CasoCreateModal
        isOpen={showCasoCreateModal}
        onClose={() => setShowCasoCreateModal(false)}
        customer={customer}
        onCasoCreated={(newCaso) => {
          setShowCasoCreateModal(false);
          // Refresh or update casos list if needed
        }}
      />

    </Box>
  )}
    </>
  );
};

export default React.memo(Profile);